import {
  OPEN_VELOCITY_CURVES,
  CLOSE_VELOCITY_CURVES,
  SELECT_VELOCITY_CURVE,
  SELECT_USER_CURVE,
  SET_USER_CURVE
} from './actionTypes'

export const openVelocityCurves = (active) => {
  return (dispatch) => {
    dispatch({ type: OPEN_VELOCITY_CURVES })
  }
};

export const closeVelocityCurves = () => {
  return ({type: CLOSE_VELOCITY_CURVES})
}

export const selectVelocityCurve = (index) => ({ type: SELECT_VELOCITY_CURVE, index: index });
export const selectUserCurve = (index) => ({ type: SELECT_USER_CURVE, index: index });

export const setUserCurve = (index, curve) => ({ type: SET_USER_CURVE, index: index, curve: [...curve] });
